import { render, staticRenderFns } from "./Contabilista.vue?vue&type=template&id=667e8f7c&scoped=true"
import script from "./Contabilista.vue?vue&type=script&lang=js"
export * from "./Contabilista.vue?vue&type=script&lang=js"
import style0 from "./Contabilista.vue?vue&type=style&index=0&id=667e8f7c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667e8f7c",
  null
  
)

export default component.exports